import appMiddleware from "@/middleware/app";

export default {
  mode: "history",
  baseURL: process.env.VUE_APP_API,
  middleware: [appMiddleware],
};
